import { Injectable } from '@angular/core'
import { HttpErrorResponse } from '@angular/common/http'
import {TranslateHttpLoader} from '@ngx-translate/http-loader'
import {  HttpClient} from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core'
import { RouteDataService } from './RouteDataService';
import { BehaviorSubject, Observable, catchError, filter, of, switchMap } from 'rxjs';
import { NavigationEnd,Router,ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomHttpLoader implements TranslateLoader {
  /*   public prefix: string = 'https://assetsuat.icreditworks.com/public/webapp/assets/other/i18n/';
    public suffix: string = '.json'; */
    //public activeRoute$ = new BehaviorSubject<string>("default");
   // public myservice: MyUserService;
  // public router: Router
  constructor(private http: HttpClient) { }
  
  public getTranslation(lang: string): any {
     //this.user.currentRoute$.subscribe((res :any) => {
     //  const prefix= 'https://assetsuat.icreditworks.com/public/website/assets/others/i18n/';
     //const prefix= `${environment.ASSETS_CDN_BASE_URL}others/i18n/`;
     const prefix= `${environment.ASSETS_CDN_BASE_URL}/`;
     const suffix='.json';
      // const group: string = this.user.getUserGroup();  // The secret is here!
      console.log('Translation ActiveRoutePath: ' + window.location.pathname);
        let group;
        let currentRoute = window.location.pathname
        switch (true) {
          case currentRoute?.indexOf('hsfs') > -1:
            group = "hsfs"
            break;
          default:
            group = "dental"
            break;
        }
         const filename = `${group}/others/i18n/${lang}`;
          console.log('UrlConstruct: ' + prefix + filename + suffix);
          return this.http.get(prefix + filename + suffix);
       //})


      /* return this.activeRoute$.asObservable().pipe(
        filter(isUserLogged => isUserLogged),
          switchMap(() => this.http.get(this.prefix + filename + this.suffix),
            catchError(() => of(null))
        )
      ) */

    /* this.activeRoute$.subscribe((res :any) => {
       const group: string = this.user.getUserGroup();  // The secret is here!
       console.log('LOGGG: ' + group)
       const filename = `${group}/${lang}`;
       //const filename = `${lang}`;
       return this.http.get(this.prefix + filename + this.suffix);
     })  */

    /*  const group: string = this.user.getUserGroup();
      console.log('LOGGG: ' + group)
      const filename = `${group}/${lang}`;

    return this.activeRoute$.subscribe((res: any) => {
     const group: string = this.user.getUserGroup();  // The secret is here!

     console.log('LOGGG11: ' + group)
     const filename = `${group}/${lang}`;
     //const filename = `${lang}`;
     return this.http.get(this.prefix + filename + this.suffix);
    }) */

    /*    return this.activeRoute$.asObservable().subscribe((res: any) => {
      const group: string = this.user.getUserGroup();  // The secret is here!

     console.log('LOGGG11: ' + group)
       const filename = `${group}/${lang}`;
       //const filename = `${lang}`;
       return this.http.get(this.prefix + filename + this.suffix);
     })  */


    /*    return this.activeRoute$.asObservable().pipe(
          () => this.http.get(this.prefix + filename + this.suffix),
            catchError(() => of(null))
        ) 
    */
  }
  }